import {Badge} from 'react-bootstrap'

export default function TutorProfileSubjectLevelsList({tutorProfile}) {

  return (
    <>
      {tutorProfile.subjects.map(subject => {
        const sortedSubjectLevels = tutorProfile.subjectLevels.sort((a, b) => (
          a.subject.position - b.subject.position || a.level.position - b.level.position
        ))
        const filteredSubjectLevels = sortedSubjectLevels.filter(subjectLevel => subjectLevel.subject.id === subject.id)

        return (
          <div key={subject.id}>
            <div className="mb-2 d-flex flex-wrap">
              <strong className="d-block mb-2 w-100">{subject.name}</strong>

              {filteredSubjectLevels.map(subjectLevel => (
                <span className="bg-light p-2 rounded me-2 mb-2" key={subjectLevel.id}>
                  {subjectLevel.level.name}
                </span>
              ))}
            </div>
          </div>
        )
      })}
    </>
  )
}
